import React from 'react'
import Cleave from 'cleave.js/react'
function InputPhonePersonal({ value, onChange, ...other }) {
  const options = { blocks: [2, 4, 4], uppercase: true, numericOnly: true }
  const isValid = value.length === 10
  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace(/[^0-9]/g, '') // Remove non-numeric characters
    onChange(inputValue)
  }
  return (
    <div>
      <Cleave
        className={`form-control`}
        value={value}
        onChange={handleInputChange}
        options={options}
        id="prefix"
        {...other}
      />
      {!isValid && value.length !== 12 ? (
        <div className="invalid-feedback">โปรดระบุหมายเลขโทรศัพท์ 10 หลัก</div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default InputPhonePersonal
